import styled from 'styled-components';

export const FiltersDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 25px;
  margin-bottom: 25px;
`;
